import { LayoutsMap, RoutesMap } from './router.types.ts';
import type { IRoute } from './router.types.ts';

export const routesModel = {
  [RoutesMap.LOGIN]: {
    id: RoutesMap.LOGIN,
    name: 'Login',
    path: '/login',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.WELCOME]: {
    id: RoutesMap.WELCOME,
    name: 'welcome',
    path: '/welcome',
    layoutType: LayoutsMap.DEFAULT,
  },

  [RoutesMap.PERSONAL_DETAILS]: {
    id: RoutesMap.PERSONAL_DETAILS,
    name: 'Contact',
    path: '/personal-details',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.PHONE]: {
    id: RoutesMap.PHONE,
    name: 'Phone Number',
    path: '/phone',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.IDENTITY]: {
    id: RoutesMap.IDENTITY,
    name: 'Identity',
    path: '/identity',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.HOME_ADDRESS]: {
    id: RoutesMap.HOME_ADDRESS,
    name: 'Home Address',
    path: '/home-address',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.PLAN_SELECTION]: {
    id: RoutesMap.PLAN_SELECTION,
    name: 'Choose a Plan',
    path: '/plan-selection',
    layoutType: LayoutsMap.BASIC,
  },
  [RoutesMap.KNOW_YOUR_BUSINESS]: {
    id: RoutesMap.KNOW_YOUR_BUSINESS,
    groupId: 'Business Details',
    name: 'Know your business',
    path: '/know-your-business',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.REGISTERED_ADDRESS]: {
    id: RoutesMap.REGISTERED_ADDRESS,
    groupId: 'Business Details',
    name: 'Business address',
    path: '/registered-address',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.BUSINESS_ADDRESS]: {
    id: RoutesMap.BUSINESS_ADDRESS,
    groupId: 'Business Details',
    name: 'Business address',
    path: '/business-address',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_ADDITIONAL_BUSINESS_LOCATIONS]: {
    id: RoutesMap.EDD_ADDITIONAL_BUSINESS_LOCATIONS,
    groupId: 'Business Details',
    name: 'Additional Business Locations',
    path: '/additional-business-locations',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_INTERNATIONAL_ACTIVITY]: {
    id: RoutesMap.EDD_INTERNATIONAL_ACTIVITY,
    groupId: 'Business Details',
    name: 'International Activity',
    path: '/international-activity',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_BUSINESS_SIZE]: {
    id: RoutesMap.EDD_BUSINESS_SIZE,
    groupId: 'Business Details',
    name: 'Business Size',
    path: '/business-size',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_ANNUAL_REVENUE]: {
    id: RoutesMap.EDD_ANNUAL_REVENUE,
    groupId: 'Business Details',
    name: 'Annual Revenue',
    path: '/annual-revenue',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_INTENDED_USE]: {
    id: RoutesMap.EDD_INTENDED_USE,
    groupId: 'Business Details',
    name: 'Intended Use',
    path: '/intended-use',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_WEBSITE_SOCIAL]: {
    id: RoutesMap.EDD_WEBSITE_SOCIAL,
    groupId: 'Business Details',
    name: 'Website and Social Media',
    path: '/website-social',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_BUSINESS_CAPITAL]: {
    id: RoutesMap.EDD_BUSINESS_CAPITAL,
    groupId: 'Business Details',
    name: 'Business Capital Source',
    path: '/business-capital',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_FUNDING_SOURCES]: {
    id: RoutesMap.EDD_FUNDING_SOURCES,
    groupId: 'Business Details',
    name: 'Funding Sources',
    path: '/funding-sources',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_FUNDING_SOURCES]: {
    id: RoutesMap.EDD_NONPROFIT_FUNDING_SOURCES,
    groupId: 'Business Details',
    name: 'Non-Profit Funding Sources',
    path: '/nonprofit-funding-sources',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_DONORS]: {
    id: RoutesMap.EDD_NONPROFIT_DONORS,
    groupId: 'Business Details',
    name: 'Non-Profit Donors',
    path: '/nonprofit-donors',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_ORGANIZATION_SIZE]: {
    id: RoutesMap.EDD_NONPROFIT_ORGANIZATION_SIZE,
    groupId: 'Business Details',
    name: 'Non-Profit Organization Size',
    path: '/nonprofit-organization-size',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_MONTHLY_ACTIVITY]: {
    id: RoutesMap.EDD_NONPROFIT_MONTHLY_ACTIVITY,
    groupId: 'Business Details',
    name: 'Non-Profit Monthly Activity',
    path: '/nonprofit-monthly-activity',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_AFFILIATION]: {
    id: RoutesMap.EDD_NONPROFIT_AFFILIATION,
    groupId: 'Business Details',
    name: 'Non-Profit Affiliation',
    path: '/nonprofit-affiliation',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_SOCIAL_MEDIA]: {
    id: RoutesMap.EDD_NONPROFIT_SOCIAL_MEDIA,
    groupId: 'Business Details',
    name: 'Non-Profit Social Media',
    path: '/nonprofit-social-media',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_ORGANIZATION_ROLE]: {
    id: RoutesMap.EDD_ORGANIZATION_ROLE,
    groupId: 'Business Details',
    name: 'Organization Role',
    path: '/organization-role',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_DESCRIPTION]: {
    id: RoutesMap.EDD_NONPROFIT_DESCRIPTION,
    groupId: 'Business Details',
    name: 'Non-Profit Description',
    path: '/non-profit-description',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_DESCRIPTION_B]: {
    id: RoutesMap.EDD_NONPROFIT_DESCRIPTION_B,
    groupId: 'Business Details',
    name: 'Non-Profit Description B',
    path: '/non-profit-description-b',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_DESCRIPTION_C]: {
    id: RoutesMap.EDD_NONPROFIT_DESCRIPTION_C,
    groupId: 'Business Details',
    name: 'Non-Profit Description C',
    path: '/non-profit-description-c',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_DESCRIPTION_D]: {
    id: RoutesMap.EDD_NONPROFIT_DESCRIPTION_D,
    groupId: 'Business Details',
    name: 'Non-Profit Description D',
    path: '/non-profit-description-d',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_NONPROFIT_DESCRIPTION_E]: {
    id: RoutesMap.EDD_NONPROFIT_DESCRIPTION_E,
    groupId: 'Business Details',
    name: 'Non-Profit Description E',
    path: '/non-profit-description-e',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_BENEFICIARY_SELECTION]: {
    id: RoutesMap.EDD_BENEFICIARY_SELECTION,
    groupId: 'Business Details',
    name: 'Beneficiary Selection',
    path: '/beneficiary-selection',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.MAILING_ADDRESS]: {
    id: RoutesMap.MAILING_ADDRESS,
    groupId: 'Business Details',
    name: 'Card shipment address',
    path: '/mailing-address',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.CDD_ACH_VOLUMES]: {
    id: RoutesMap.CDD_ACH_VOLUMES,
    groupId: 'Business Details',
    name: 'ACH Volumes',
    path: '/cdd-ach-volumes',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.CDD_DOMESTIC_WIRE_VOLUMES]: {
    id: RoutesMap.CDD_DOMESTIC_WIRE_VOLUMES,
    groupId: 'Business Details',
    name: 'Domestic Wire Volumes',
    path: '/cdd-domestic-wire-volumes',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.CDD_INTERNATIONAL_WIRES_VOLUMES]: {
    id: RoutesMap.CDD_INTERNATIONAL_WIRES_VOLUMES,
    groupId: 'Business Details',
    name: 'International Wires Volumes',
    path: '/cdd-international-wires-volumes',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.INDUSTRY]: {
    id: RoutesMap.INDUSTRY,
    groupId: 'Business Details',
    name: 'Business industry',
    path: '/industry',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.BUSINESS_TYPE_SELECTION]: {
    id: RoutesMap.BUSINESS_TYPE_SELECTION,
    groupId: 'Business Details',
    name: 'Business type selection',
    path: '/business-type',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.ADD_OWNER]: {
    id: RoutesMap.ADD_OWNER,
    groupId: 'Owners Center',
    name: 'Add Owner',
    path: '/add-owner',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.REVIEW]: {
    id: RoutesMap.REVIEW,
    name: 'Confirmation',
    path: '/review-details',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.KYB_PENDING]: {
    id: RoutesMap.KYB_PENDING,
    name: 'KYB Pending',
    path: '/kyb-pending',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.VERIFICATION_CENTER]: {
    id: RoutesMap.VERIFICATION_CENTER,
    name: 'Verification Center',
    path: '/verification-center',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.SUCCESS]: {
    id: RoutesMap.SUCCESS,
    name: 'Success',
    path: '/success',
    layoutType: LayoutsMap.EMPTY,
  },
  [RoutesMap.SUCCESS_WITHOUT_AUTO_LOGIN]: {
    id: RoutesMap.SUCCESS_WITHOUT_AUTO_LOGIN,
    name: 'Success',
    path: '/success-without-auto-login',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.FAILD_UPLOAD]: {
    id: RoutesMap.FAILD_UPLOAD,
    name: 'Failed Upload',
    path: '/failed-upload',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.DEBIT_CARD_NAME]: {
    id: RoutesMap.DEBIT_CARD_NAME,
    name: 'Debit Card Name',
    path: '/debit-card-name',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.OWNER_CENTER]: {
    id: RoutesMap.OWNER_CENTER,
    groupId: 'Owners Center',
    name: 'Owners Center',
    path: '/owners-center',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.GENERIC_MESSAGE_PAGE]: {
    id: RoutesMap.GENERIC_MESSAGE_PAGE,
    name: 'Generic Message Page',
    path: '/generic-message',
    layoutType: LayoutsMap.EDGE_CASE,
  },
  [RoutesMap.UNDER_REVIEW]: {
    id: RoutesMap.UNDER_REVIEW,
    name: 'Under Review',
    path: '/under-review',
    layoutType: LayoutsMap.EMPTY,
  },
  [RoutesMap.ONE_OF_US]: {
    id: RoutesMap.ONE_OF_US,
    name: 'One Of Us',
    path: '/one-of-us',
    layoutType: LayoutsMap.EMPTY,
  },
  [RoutesMap.KYC_FAILED]: {
    id: RoutesMap.KYC_FAILED,
    name: 'KYC Failed',
    path: '/failed',
    layoutType: LayoutsMap.EMPTY,
  },
  [RoutesMap.ACCOUNT_OPENING_REASON]: {
    id: RoutesMap.ACCOUNT_OPENING_REASON,
    name: 'Account Opening Reason',
    groupId: 'Confirmation',
    layoutType: LayoutsMap.HAPPY_FLOW,
    path: '/account-opening-reason',
  },
  [RoutesMap.INVITE_TEAM_MEMBER_INTRO]: {
    id: RoutesMap.INVITE_TEAM_MEMBER_INTRO,
    name: 'Invite Team Member Intro',
    path: '/invite-team-member-intro',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.VERIFY_PHONE_NUMBER]: {
    id: RoutesMap.VERIFY_PHONE_NUMBER,
    name: 'Verify Phone',
    path: '/verify-phone-number',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.SET_PASSWORD]: {
    id: RoutesMap.SET_PASSWORD,
    name: 'Create Password',
    path: '/set-password',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.INVITE_TEAM_MEMBER_FINISHED]: {
    id: RoutesMap.INVITE_TEAM_MEMBER_FINISHED,
    name: 'Invite Team Member Success',
    path: '/invite-team-member-finished',
    layoutType: LayoutsMap.DEFAULT,
  },

  [RoutesMap.NON_US_SOCURE]: {
    id: RoutesMap.NON_US_SOCURE,
    name: 'Verification ',
    path: '/verificationNUSocure',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.LOGIN_OTP_VERIFICATION]: {
    id: RoutesMap.LOGIN_OTP_VERIFICATION,
    name: 'Login Verification Code',
    path: '/login-otp-verification',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.RECOVERY]: {
    id: RoutesMap.RECOVERY,
    name: 'Recovery',
    path: '/recovery',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.RESET_PASSWORD_REQUEST]: {
    id: RoutesMap.RESET_PASSWORD_REQUEST,
    name: 'Reset Password Request',
    path: '/reset-password-request',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.SECURITY_QUESTION]: {
    id: RoutesMap.SECURITY_QUESTION,
    name: 'Security Question',
    path: '/security-question',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.RECOVERY_VERIFICATION_CODE]: {
    id: RoutesMap.RECOVERY_VERIFICATION_CODE,
    name: 'Verification Code',
    path: '/verification-code',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.RECOVERY_TYPE]: {
    id: RoutesMap.RECOVERY_TYPE,
    name: 'Recovery Type',
    path: '/recovery-type',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.RECOVERY_SET_PASSWORD]: {
    id: RoutesMap.RECOVERY_SET_PASSWORD,
    name: 'Recovery Set Password',
    path: '/recovery-set-password',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.EMAIL_VERIFICATION]: {
    id: RoutesMap.EMAIL_VERIFICATION,
    name: 'Email Verification',
    path: '/email-verification',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.UBO_ONBOARDING_INTRO]: {
    id: RoutesMap.UBO_ONBOARDING_INTRO,
    name: 'Intro',
    path: '/ubo-onboarding-intro',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.UBO_ONBOARDING_VALIDATE_PHONE]: {
    id: RoutesMap.UBO_ONBOARDING_VALIDATE_PHONE,
    name: 'Verification',
    path: '/ubo-onboarding-validate-phone',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.UBO_ONBOARDING_ID_VERIFICATION]: {
    id: RoutesMap.UBO_ONBOARDING_ID_VERIFICATION,
    name: 'Security Question',
    path: '/ubo-onboarding-id-verification',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.UBO_ONBOARDING_CREATE_PASSWORD]: {
    id: RoutesMap.UBO_ONBOARDING_CREATE_PASSWORD,
    name: 'Create Password',
    path: '/ubo-onboarding-create-password',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.UBO_ONBOARDING_DOCV]: {
    id: RoutesMap.UBO_ONBOARDING_DOCV,
    name: 'Document Verification',
    path: '/ubo-onboarding-docv',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.VERIFICATION_FAILED]: {
    id: RoutesMap.VERIFICATION_FAILED,
    name: 'Verification Failed',
    path: '/verification-failed',
    layoutType: LayoutsMap.EMPTY,
  },
  [RoutesMap.EDD_EMBEDDED_WHAT_DO_YOU_SELL]: {
    id: RoutesMap.EDD_EMBEDDED_WHAT_DO_YOU_SELL,
    groupId: 'Business Details',
    name: 'Edd Questions',
    path: '/edd-embedded-what-do-you-sell',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_EMBEDDED_TO_WHO_YOU_SELL]: {
    id: RoutesMap.EDD_EMBEDDED_TO_WHO_YOU_SELL,
    groupId: 'Business Details',
    name: 'Edd Questions',
    path: '/edd-embedded-to-who-you-sell',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_EMBEDDED_WHY_DID_YOU_CHOOSE]: {
    id: RoutesMap.EDD_EMBEDDED_WHY_DID_YOU_CHOOSE,
    groupId: 'Business Details',
    name: 'Edd Questions',
    path: '/edd-embedded-why-did-you-choose',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_EMBEDDED_BUSINESS_COUNTRIES]: {
    id: RoutesMap.EDD_EMBEDDED_BUSINESS_COUNTRIES,
    groupId: 'Business Details',
    name: 'Edd Questions',
    path: '/edd-embedded-business-countries',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME]: {
    id: RoutesMap.EDD_EMBEDDED_MONTHLY_PAYMENT_VOLUME,
    groupId: 'Business Details',
    name: 'Edd Questions',
    path: '/edd-embedded-monthly-payment-volume',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_SANCTIONED_COUNTRIES]: {
    id: RoutesMap.EDD_SANCTIONED_COUNTRIES,
    groupId: 'Business Details',
    name: 'Sanctioned Countries',
    path: '/sanctioned-countries',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_CHARITIES]: {
    id: RoutesMap.EDD_CHARITIES,
    groupId: 'Business Details',
    name: 'Charities',
    path: '/charities',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_MILITARY_PRECIOUS_METALS]: {
    id: RoutesMap.EDD_MILITARY_PRECIOUS_METALS,
    groupId: 'Business Details',
    name: 'Military & Precious Metals',
    path: '/military-precious-metals',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_CASH_PAYMENTS]: {
    id: RoutesMap.EDD_CASH_PAYMENTS,
    groupId: 'Business Details',
    name: 'Cash Payments',
    path: '/cash-payments',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_TAX_LEGAL_SERVICES]: {
    id: RoutesMap.EDD_TAX_LEGAL_SERVICES,
    groupId: 'Business Details',
    name: 'Tax & Legal Services',
    path: '/tax-legal-services',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_FUND_TRANSFER]: {
    id: RoutesMap.EDD_FUND_TRANSFER,
    groupId: 'Business Details',
    name: 'Fund Transfer',
    path: '/fund-transfer',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.EDD_INVESTMENT_CUSTODIAL]: {
    id: RoutesMap.EDD_INVESTMENT_CUSTODIAL,
    groupId: 'Business Details',
    name: 'Investment Advice & Custodial',
    path: '/investment-custodial',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.AUTO_LOGIN]: {
    id: RoutesMap.AUTO_LOGIN,
    name: 'Auto Login',
    path: '/auto-login',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.RECOVERY_SUCCESS]: {
    id: RoutesMap.RECOVERY_SUCCESS,
    name: 'Recovery Success',
    path: '/recovery-success',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.MULTI_BUSINESS_ONBOARDING_INTRO]: {
    id: RoutesMap.MULTI_BUSINESS_ONBOARDING_INTRO,
    name: 'Intro',
    path: '/multi-business-intro',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.AUTH_USER_PHONE]: {
    id: RoutesMap.AUTH_USER_PHONE,
    name: 'Phone Number',
    path: '/auth-user-phone',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.AUTH_USER_IDENTITY]: {
    id: RoutesMap.AUTH_USER_IDENTITY,
    name: 'Personal Details',
    path: '/auth-user-identity',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.AUTH_USER_HOME_ADDRESS]: {
    id: RoutesMap.AUTH_USER_HOME_ADDRESS,
    name: 'Personal Details',
    path: '/auth-user-home-address',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.AUTH_USER_DOCV]: {
    id: RoutesMap.AUTH_USER_DOCV,
    name: 'Verification',
    path: '/auth-user-docv',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.ACCOUNTANT_PORTAL_WELCOME]: {
    id: RoutesMap.ACCOUNTANT_PORTAL_WELCOME,
    name: 'Welcome',
    path: '/accountant-portal-welcome',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.ACCOUNTANT_PORTAL_COMPLETE]: {
    id: RoutesMap.ACCOUNTANT_PORTAL_COMPLETE,
    name: 'Complete',
    path: '/accountant-portal-complete',
    layoutType: LayoutsMap.DEFAULT,
  },
} as const satisfies Record<RoutesMap, IRoute>;

export type RoutesModel = typeof routesModel;

//TODO: verify if this needs to be 0 or -1
export const DEFAULT_PAGE_INDEX = 0;

export const getRouteByPath = (path: string): IRoute | undefined => {
  return Object.values(routesModel).find((route) => route.path === path);
};
